import { render, staticRenderFns } from "./competitionStudent.vue?vue&type=template&id=13bd434e&scoped=true&"
import script from "./competitionStudent.vue?vue&type=script&lang=js&"
export * from "./competitionStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd434e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13bd434e')) {
      api.createRecord('13bd434e', component.options)
    } else {
      api.reload('13bd434e', component.options)
    }
    module.hot.accept("./competitionStudent.vue?vue&type=template&id=13bd434e&scoped=true&", function () {
      api.rerender('13bd434e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/competitionStudent.vue"
export default component.exports